import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TipoAltroSoggetto } from '../models/tipo-altro-soggetto';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class TipoAltroSoggettoService extends ResourcefulService<TipoAltroSoggetto>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, TipoAltroSoggetto);
    }
}
